module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_thick_mask.26452b00.png";